function showCustomConfirmation(message) {
  return new Promise((resolve) => {
    const popup = document.getElementById('custom-popup');
    const messageBox = document.getElementById('custom-popup-message');
    const yesBtn = document.getElementById('popup-yes');
    const noBtn = document.getElementById('popup-no');

    // Allow HTML inside the message
    messageBox.innerHTML = message;
    popup.classList.remove('hidden');

    const cleanup = () => {
      popup.classList.add('hidden');
      yesBtn.removeEventListener('click', onYes);
      noBtn.removeEventListener('click', onNo);
    };

    const onYes = () => {
      cleanup();
      resolve(true);
    };

    const onNo = () => {
      cleanup();
      resolve(false);
    };

    yesBtn.addEventListener('click', onYes);
    noBtn.addEventListener('click', onNo);
  });
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const isSeedProduct = window.productFlags?.isSeedProduct;
      const isPreEmergentProduct = window.productFlags?.isPreEmergentProduct;

      try {
        const cart = await fetch('/cart.js').then(res => res.json());

        let showConfirmation = false;
        let conflictMessage = '';

        cart.items.forEach(item => {
          const itemTitle = item.title?.toLowerCase() || '';
          const itemType = item.product_type?.toLowerCase() || '';

          if (isSeedProduct && itemTitle.includes('pre-emergent')) {
            showConfirmation = true;
            conflictMessage = `Your cart contains a Pre-Emergen. We do not recommend applying Pre-Emergents and Grass Seed at the same time. The seed will not grow. Check out our <a href="/products/starter-fertilizer-15-20-10" target="_blank">Starter Fertilizer</a>, which will boost seed growth. Do you still want to add this Grass Seed?`;
          }

          if (isPreEmergentProduct && itemType === 'seed') {
            showConfirmation = true;
            conflictMessage = `Your cart contains a Grass Seed. We do not recommend applying Pre-Emergents and Grass Seed at the same time. The seed will not grow. Check out our <a href="/products/starter-fertilizer-15-20-10" target="_blank">Starter Fertilizer</a>, which will boost seed growth. Do you still want to add this Pre-emergent?`;
          }
        });

        if (showConfirmation) {
          const userConfirmed = await showCustomConfirmation(conflictMessage);
          if (!userConfirmed) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            return;
          }
        }

        const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
          }
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }

      } catch (e) {
        console.error(e);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
